import setupAccordion from './accordion.js'
import setupBasket from './basket.js'
import setupCustomCheckout from './custom-checkout.js'
import setupDashboard from './dashboard.js'
// Multibuy cross-sell pill disabled for now — the "25% off" label reads as a
// blanket per-show discount when it only applies once a 2nd show is added.
// Re-enable by restoring this import + the setupMultibuyLabels() call below.
// import setupMultibuyLabels from './multibuy-labels.js'
import setupNav from './nav.js'
import setupSearch from './search.js'
import setupShowAll from './show-all.js'
import setupVenueCarousel from './venue-carousel.js'
import setupFixedHero from './fixed-hero.js'
import setupFilterScrollAdjust from './filter-scroll-adjust.js'

/**
 * Scripts are deferred until the document is loaded, so there is no need to listen to the `DOMContentLoaded` event.
 * Ensure you split functionality up into their own modules.
 */
setupAccordion()
setupBasket()
setupCustomCheckout()
setupDashboard()
// setupMultibuyLabels() — disabled for now (see import note above)
setupNav()
setupSearch()
setupShowAll()
setupVenueCarousel()
setupFixedHero()
setupFilterScrollAdjust()

